// Types
import Vue from"vue";const RegisterView=Vue.extend({name:"RegisterView",render(){const a=arguments[0];return a("div",["Register"])}});export default RegisterView;